// import { store, actions } from '@store';
import { toast } from 'react-toastify';
import { addDays, subYears, format } from 'date-fns'

// import { resetNavigation } from "@routes/navigation";

import { tokenizeCard } from '../api/pagarme';
import { getZipcode } from '../api/bernabeu';

import {
  postCreditCards,
  getCreditCards,
  deleteCreditCard,
} from "../api/bernabeu";

import {
  creditCardSlice,
  callTypes
} from "../../redux/reducers/creditCardSlice";

const { actions } = creditCardSlice;

const fetchCreateCreditCard= (
  cardNumber,
  holder_name,
  month,
  year,
  cvv,
  holderDocument,
  label,
  country,
  state,
  city,
  zip_code,
  address,
  number,
  line_2,
  neighborhood
) => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(actions.startCall({ callType: callTypes.action }));

    let params: any = {
      "type": "card",
      "card": {
          "number": cardNumber,
          "holder_name": holder_name,
          "holder_document": holderDocument,
          "exp_month": month,
          "exp_year": year,
          "cvv": cvv,
      }
    }

    if (label) {
      params.card.label = label;
    }

    tokenizeCard(params).then((response : any) => {
      postCreditCards({
        token: response.id,
        brand: response.card.brand,
        document: holderDocument,
        address: {
          country: "BR",
          state: state,
          city: city,
          zip_code: zip_code,
          address: address,
          number: number,
          line_2: "",
          neighborhood: neighborhood
        }
      }).then(responseCard => {
        resolve(responseCard);
      }).catch((error) => {
        // dispatch(actions.creditCardsFetched({ status: 'completed' }));

        // Toast.show({
        //   type: 'error',
        //   text1: 'Seu cartão foi recusado ou está inválido',
        //   text2: error.message
        // });
        toast.error('Erro ao cadastrar o cartão!')

        // reject(error.response.data.errors);
        reject(error.response.data.message);
        dispatch(actions.creditCardsCreated());

      }).finally(() => {
        dispatch(actions.creditCardsCreated());
      });
    }).catch((error) => {
      // dispatch(actions.creditCardsFetched({ status: 'completed' }));

      toast.error('Erro ao tokenizar cartão! Verifique os dados preenchidos')
    }).finally(() => {
      dispatch(actions.creditCardsCreated());
    });
  });
}

const fetchGetCep = (cep) => {
  return new Promise((resolve, reject) => {
    getZipcode(cep).then(response => {
      // dispatch(actions.creditCardsFetched({ status: 'completed', data: response }));
      console.log(response);
      resolve(response)
    }).catch((error) => {
      console.log('fetchGetCep falhou:');
      console.log({error});

      reject(error);
    });
  });
}

const fetchCreditCards = () => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));

  getCreditCards().then((response : any) => {
    dispatch(actions.creditCardsFetched({ status: 'completed', entities: response.data }));
  }).catch((error) => {
    console.log('fetchCreditCards falhou:');
    console.log({error});

    dispatch(actions.creditCardsFetched({ status: 'completed', entities: [] }));
  });
}

const fetchDeleteCreditCard = (creditCardId) => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(actions.startCall({ callType: callTypes.action }));

    deleteCreditCard(creditCardId).then(response => {
      dispatch(actions.creditCardsDeleted());
      toast.success('Cartão excluído!');

      resolve(true);
    }).catch((error) => {
      console.log('fetchDeleteCreditCard falhou:');
      console.log({error});

      dispatch(actions.creditCardsDeleted());

      let message = error.response?.data?.message ?? 'Erro ao excluir o cartão!';

      toast.error(message);

      reject(false);
    });
  });
}

export {
  fetchCreateCreditCard,
  fetchGetCep,
  fetchCreditCards,
  fetchDeleteCreditCard
}